import React from 'react'

import { Star, StarHalf, StarOutline } from '@mui/icons-material'

import { REVIEWER_ROLES } from 'utils/constants/userRoles'

import styles from './styles'
import BuildListItem from './BuildListItem'

export default function ManualAnalysisList(props) {
  const { issuesList, onSubmitReview } = props

  const classes = styles()

  const splitAreas = (issues) => {
    const analist = []
    const supervisor = []
    const manager = []
    if (issues.length > 0) {
      issues.forEach((issue) => {
        if (issue.current_review_area === REVIEWER_ROLES.ANALYST)
          analist.push(issue)
        if (issue.current_review_area === REVIEWER_ROLES.SUPERVISOR)
          supervisor.push(issue)
        if (issue.current_review_area === REVIEWER_ROLES.MANAGER)
          manager.push(issue)
      })
    }

    return {
      analistIssues: analist,
      supervisorIssues: supervisor,
      managerIssues: manager,
    }
  }

  const { analistIssues, supervisorIssues, managerIssues } =
    splitAreas(issuesList)

  return (
    <div className={classes.root}>
      {analistIssues.length > 0 ? (
        <div className={classes.areaContainer}>
          <div className={classes.areaTitle}>
            <StarOutline />
            <h3>Análise(s) requerida(s) dos Analistas:</h3>
          </div>
          {analistIssues.map((issue) => {
            return <BuildListItem key={issue.uuid} issue={issue} onSubmitReview={onSubmitReview} />
          })}
        </div>
      ) : null}
      {supervisorIssues.length > 0 ? (
        <div className={classes.areaContainer}>
          <div className={classes.areaTitle}>
            <StarHalf />
            <h3>Análise(s) requerida(s) dos Supervisores:</h3>
          </div>
          {supervisorIssues.map((issue) => {
            return <BuildListItem key={issue.uuid} issue={issue} onSubmitReview={onSubmitReview} />
          })}
        </div>
      ) : null}
      {managerIssues.length > 0 ? (
        <div className={classes.areaContainer}>
          <div className={classes.areaTitle}>
            <Star />
            <h3>Análise(s) requerida(s) dos Gestores:</h3>
          </div>
          {managerIssues.map((issue) => {
            return <BuildListItem key={issue.uuid} issue={issue} onSubmitReview={onSubmitReview} />
          })}
        </div>
      ) : null}
    </div>
  )
}
